import { render } from "./AcademyBoxes.vue?vue&type=template&id=b9be3cda"
import script from "./AcademyBoxes.vue?vue&type=script&lang=js"
export * from "./AcademyBoxes.vue?vue&type=script&lang=js"

import "./AcademyBoxes.vue?vue&type=style&index=0&id=b9be3cda&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__